"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadCell = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var Checkbox_1 = require("../Checkbox");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var DataTableContext_1 = require("./DataTableContext");
var HeadCell = function (_a) {
    var thClassName = _a.thClassName, column = _a.column, renderHeading = _a.renderHeading, selectable = _a.selectable, hideSelectHeader = _a.hideSelectHeader, leading = _a.leading;
    var _b = (0, DataTableContext_1.useTableContext)(), addSortable = _b.addSortable, onSort = _b.onSort, sortBy = _b.sortBy, onSelectAll = _b.onSelectAll, data = _b.data, selectedRows = _b.selectedRows;
    var allRowsSelected = (0, react_1.useMemo)(function () { return (data === null || data === void 0 ? void 0 : data.length) > 0 && data.length === (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length); }, [data, selectedRows]);
    var someRowsSelected = (0, react_1.useMemo)(function () {
        return (data === null || data === void 0 ? void 0 : data.length) > 0 &&
            (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) > 0 &&
            data.length !== (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length);
    }, [data, selectedRows]);
    (0, react_1.useEffect)(function () {
        if (column === null || column === void 0 ? void 0 : column.sortable) {
            addSortable === null || addSortable === void 0 ? void 0 : addSortable(column === null || column === void 0 ? void 0 : column.name, column === null || column === void 0 ? void 0 : column.order);
        }
    }, [column]);
    var handleSort = function (name) { return function () {
        onSort === null || onSort === void 0 ? void 0 : onSort(name);
    }; };
    var handleSelectAll = function (checked) {
        onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(checked);
    };
    if (!column) {
        return ((0, jsx_runtime_1.jsx)("th", __assign({ className: (0, classnames_1.default)(thClassName, leading
                ? 'squid-pr-0 squid-max-w-min squid-pl-component-table-cell-padding-base squid-py-component-table-cell-padding-tight'
                : 'squid-px-component-table-cell-padding-tighter squid-py-component-table-cell-padding-tight') }, { children: selectable && !hideSelectHeader && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-items-center', leading
                    ? 'squid-justify-start squid-max-w-min squid-mx-0'
                    : 'squid-justify-center') }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { checked: allRowsSelected, indeterminate: someRowsSelected, onChange: handleSelectAll, containerClassName: "" }) }))) })));
    }
    var title = ((0, jsx_runtime_1.jsx)(Typography_1.Overline, __assign({ as: "h4", color: "weaker", className: "squid-whitespace-nowrap" }, { children: column.title })));
    var sortableColumn;
    if (column.sortable) {
        var sort = sortBy === null || sortBy === void 0 ? void 0 : sortBy.find(function (s) { return s.name === column.name; });
        var icon = (sort === null || sort === void 0 ? void 0 : sort.order) === 'desc' ? 'ChevronDown' : 'ChevronUp';
        sortableColumn = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!renderHeading && title, !!(data === null || data === void 0 ? void 0 : data.length) && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, size: "sm", fill: "base" }) }))] }));
    }
    var content;
    if (renderHeading) {
        content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderHeading(column), sortableColumn] }));
    }
    else {
        content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!(column === null || column === void 0 ? void 0 : column.sortable) && title, sortableColumn] }));
    }
    return ((0, jsx_runtime_1.jsx)("th", __assign({ className: (0, classnames_1.default)(thClassName, 'squid-px-component-table-cell-padding-tighter squid-py-component-table-cell-padding-tight', column.className), colSpan: column.colSpan }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ onClick: (data === null || data === void 0 ? void 0 : data.length) && column.sortable ? handleSort(column.name) : undefined, className: (0, classnames_1.default)('squid-flex squid-items-center squid-gap-component-table-cell-space-base', {
                'squid-justify-center': column.align === 'center',
                'squid-justify-start': !column.align || column.align === 'left',
                'squid-justify-end': column.align === 'right',
                'squid-cursor-pointer': column.sortable && (data === null || data === void 0 ? void 0 : data.length),
            }) }, { children: content })) }), column.name));
};
exports.HeadCell = HeadCell;
